import useTranslation from 'next-translate/useTranslation';
import { Flex, Input, Space, Typography } from '@arkestro/arkestro-design-system';
import { Controller } from 'react-hook-form';

import styles from './CustomFieldsPanel.module.scss';

interface CustomFieldsPanelProps {
  disableFields: boolean;
}

export const CustomFieldsPanel = ({ disableFields }: CustomFieldsPanelProps) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Flex gap={4} vertical>
        <Typography className={styles.text}>{t('bid_request.external_project_identifier')}</Typography>
        <Controller
          name='externalProjectIdentifier'
          render={({ field: { value, onChange } }) => (
            // Future changes should validate the 24 max char length
            <Input
              data-testid='external-project-identifier-input'
              disabled={disableFields}
              maxLength={24}
              onChange={onChange}
              placeholder={t('bid_request.external_project_identifier')}
              value={value}
            />
          )}
        />
      </Flex>
      <Flex gap={4} vertical>
        <Typography className={styles.text}>{t('bid_request.event_custom_fields')}</Typography>
        <Typography className={styles.hint}>{t('bid_request.custom_fields_hint')}</Typography>
        <Flex gap={8} vertical>
          <Flex>
            <Typography className={styles.columnLabel}>{t('bid_request.custom_field_name_label')}</Typography>
            <Typography className={styles.columnLabel}>{t('bid_request.custom_field_value_label')}</Typography>
          </Flex>
          <Controller
            name='customValueFields'
            render={({ field: { value: fields, onChange } }) => {
              const handleFieldChange = (index: number, key: string, newValue: string) => {
                const updated = [...fields];
                updated[index] = { ...updated[index], [key]: newValue };
                onChange(updated);
              };

              // Future changes should validate the 24 max char length
              return (fields ?? []).map((cvf: { id: string; type_text: string; value_text: string }, index: number) => (
                <Space.Compact key={cvf.id}>
                  <Input
                    data-testid={`custom-field-type-${index}`}
                    disabled={disableFields}
                    maxLength={24}
                    onChange={e => handleFieldChange(index, 'type_text', e.target.value)}
                    placeholder={t('bid_request.enter_custom_field')}
                    value={cvf.type_text}
                  />
                  <Input
                    data-testid={`custom-field-value-${index}`}
                    disabled={disableFields}
                    maxLength={24}
                    onChange={e => handleFieldChange(index, 'value_text', e.target.value)}
                    placeholder={t('bid_request.enter_custom_value')}
                    value={cvf.value_text}
                  />
                </Space.Compact>
              ));
            }}
          />
        </Flex>
      </Flex>
    </>
  );
};
